import environment from "../../environment";
import { Routes } from "../../methods/ApiRoutes";

const shared = {
  title: 'Users',
  addTitle: ' User',
  role: environment.userRole,
  url: 'user',
  ...Routes.User
};

export default shared;
